import { BASE_URL_API } from 'constants/base-url-default'
import { getCookie } from 'utils/functions-cookie'

export type ResponseStatusEmployee = {
  status: string
  percentage: string
  count: number
}

export type ResponseEmployeesBooking = {
  date: string
  total: number
}

export type StatusPercentage = {
  status: string
  percentage: number
}

export type ReservationCount = {
  date: string
  total: number
}

export type Root = {
  status_percentages: StatusPercentage[]
  reservation_counts: ReservationCount[]
  total_approximate_bill: number
  detail?: string
}

export const traduzirStatus = (status: string) => {
  switch (status) {
    case 'SUBSCRIBER':
      return 'Com Plano'
    case 'NON-SUBSCRIBER':
      return 'Sem Plano'
    case 'INACTIVE':
      return 'Inativo'
    case 'INVOICED':
      return 'Desconto em folha'
    default:
      return status
  }
}

export const fetchEmployeesByStatus = async () => {
  const authToken = getCookie('auth_token')
  const response = await fetch(`${BASE_URL_API}/companies/statistics/report`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  })

  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('Sessão expirada')
    }
    const { detail } = (await response.json()) as Root

    throw new Error(detail ?? 'Erro ao buscar dados')
  }

  return (await response.json()) as Root
}
